export default {
  home: [],
  league: []
}
